import { UserDeleteApi } from './delete-user';

export const userDeleteApi = new UserDeleteApi();
